// extracted by mini-css-extract-plugin
module.exports = {"actionLink":"styles__actionLink___XO624","alignLeft":"styles__alignLeft___1iTzE","alignRight":"styles__alignRight___3tAQj"};